import React from 'react';
import ChangeRequestListItem, { ChangeRequestListItemProps } from './ChangeRequestListItem';
import { NoResultsCard } from '@/components/Cards';
import { ChangeRequestWithChatInfo } from '@/types';
import { Trans } from '@lingui/react/macro';

type ChangeRequestListProps = Omit<ChangeRequestListItemProps, 'changeRequest' | 'defaultExpanded'> & {
    changeRequests: ChangeRequestWithChatInfo[];
    defaultExpandedId?: number;
};

const ChangeRequestList: React.FC<ChangeRequestListProps> = ({ changeRequests, defaultExpandedId, ...rest }) => {
    return (
        <>
            {changeRequests.map((changeRequest) => (
                <ChangeRequestListItem
                    defaultExpanded={defaultExpandedId === changeRequest.id}
                    key={changeRequest.id}
                    changeRequest={changeRequest}
                    {...rest}
                />
            ))}

            {changeRequests.length === 0 && (
                <NoResultsCard>
                    <Trans>No change requests</Trans>
                </NoResultsCard>
            )}
        </>
    );
};

export default ChangeRequestList;